import { render, staticRenderFns } from "./callback-tag.vue?vue&type=template&id=67619171&"
import script from "./callback-tag.vue?vue&type=script&lang=js&"
export * from "./callback-tag.vue?vue&type=script&lang=js&"
import style0 from "./callback-tag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports